export const isFieldSupportedForGrouping = (field: FieldDto) =>
    field.type !== 'multi_file' &&
    !(field.type === 'multi_lookup' && field.synthetic_field_type) &&
    !['created_by', 'updated_by'].includes(field.synthetic_field_type ?? '')
